import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';
import { PendingApprovalDialogComponent } from './../pending-approval-dialog/pending-approval-dialog.component';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginatorIntl } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { DownloadService } from '../../services/download/download.service'
import { AgentEmployeeDocsDialogComponent } from '../../components/agent-employee-docs-dialog/agent-employee-dialog.component'
import { AgentEmployeeDocsDeleteDialogComponent } from '../agent-employee-docs-delete-dialog/agent-employee-delete-dialog.component';
import * as moment from 'moment';
import { DisableRow } from '../../../shared/globalService';
import { GetDocStatusColor } from '../../../shared/globalService';

@Component({
  selector: 'app-employee-documents',
  templateUrl: './employee-documents.component.html',
  styleUrls: ['./employee-documents.component.css']
})
export class EmployeeDocumentsComponent implements OnInit {
  public documentsAllowedToUpload = [];
  public docType: any;
  public agentId: any;
  public empId: any;
  public tableData: any;
  public documentType: any;
  public employeeDocumentsList: any;
  ispaginationFlag: boolean = false;
  dataSource: MatTableDataSource<UserData>;
  pageSize = 10;
  noResults: any;
  length: any;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  docCategory: any;
  empID: any;
  errMsg;
  errFlag: boolean = false;
  dataNotFoundMsg;
  uploadedFileName;
  vendorName;
  placeholder = "Select a Document";
  public fxDisplay: any = 100;
  public clientDisplay: any = 40;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'DocumentStatus', 'FileEdit'];
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  grey: boolean = false;
  approve_reject_button: boolean = false;
  disable_edit: boolean = false;
  constructor(private downloadService: DownloadService, private agentemployeeservice: AgentEmployeeService, public dialog: MatDialog, private disabletheRow: DisableRow, private getDocStatusColor: GetDocStatusColor) { }

  ngOnInit() {
    this.uploadedFileName = 'Vendor Employee - ' + this.vendorName;
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.empId = localStorage.getItem("EmployeeId");
    this.empID = localStorage.getItem("EmployeeId");
    this.agentemployeeservice.TypeOfEmpDocs().subscribe(res => {
      if (res.Status == 200 && res.DocumentTypes !== undefined && res.DocumentTypes.length > 0) {
        this.docType = res.DocumentTypes;
        this.docCategory = this.docType[0].Category;
        this.populateDocumentTypeDropDown()
      }
      else if (res.DocumentTypes !== undefined && res.DocumentTypes.length == 0) {
        this.dataNotFoundMsg = "Employee document types data not found";
        this.errFlag = true;
      }
    });
    this.agentemployeeservice.load.subscribe(res => {
      if (res === 'success') {
        this.documentType = '';
        this.bindEmployeeDocsTable();
      }
    });
    if (this.empId == undefined || null) {
      this.empId = this.empID;
      this.bindEmployeeDocsTable();
    } else {
      this.bindEmployeeDocsTable();
    }
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
      this.fxDisplay = 50;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
      this.fxDisplay = 100;
    }
  }

  populateDocumentTypeDropDown() {
    const documentTypeFilter = () => true;
    this.documentsAllowedToUpload = this.filterDocumentTypesBy(documentTypeFilter)
  }

  filterDocumentTypesBy(filterDocumentsPredicate) {
    return this.docType.filter(filterDocumentsPredicate)
  }

  bindEmployeeDocsTable() {
    this.agentemployeeservice.getEmployeeListDocuments(this.empId, this.agentId).subscribe(res => {
      if (res.Status == 200 && res.Documents !== undefined && res.Documents.length > 0) {
        this.paginator.pageIndex = 0;
        this.noResults = '';
        this.employeeDocumentsList = res.Documents;
        for (let i = 0; i < this.employeeDocumentsList.length; i++) {
          if (this.employeeDocumentsList[i].UploadedTimeStamp != '' && this.employeeDocumentsList[i].UploadedTimeStamp != null && this.employeeDocumentsList[i].UploadedTimeStamp != undefined) {
            var momentDate = moment(this.employeeDocumentsList[i].UploadedTimeStamp).format('YYYY/MM/DD');
            this.employeeDocumentsList[i].UploadedTimeStamp = momentDate;
          }
          if (this.employeeDocumentsList[i].ExpirationDate !== '' && this.employeeDocumentsList[i].ExpirationDate !== null && this.employeeDocumentsList[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.employeeDocumentsList[i].ExpirationDate).format('YYYY/MM/DD');
            this.employeeDocumentsList[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.employeeDocumentsList);
        this.dataSource.sort = this.sort;
        this.length = this.employeeDocumentsList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
      else if (res.Documents !== undefined && res.Documents.length == 0) {
        this.employeeDocumentsList = [];
        this.dataSource = null;
        this.ispaginationFlag = false;
        this.noResults = "No documents found";
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  placeholderChange() {
    this.placeholder = "Document";
  }

  openDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;
    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentTypeName: docName.DocumentTypeName,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;
    let dialogRef = this.dialog.open(AgentEmployeeDocsDialogComponent, {
      width: '600px',
      height: '500px',
      data: { data: type === 'update' ? docName : new_Data, type: type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.documentType = '';
      this.placeholder = 'Select a Document';
    });
    localStorage.setItem('AgentEmployeeDocName', docName);
  }

  validateDoc(name, type): void {
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentTypeCode: name.DocumentTypeCode,
      DocumentTypeName: name.DocumentTypeName,
      DocumentCategory: name.DocumentCategory
    };
   
    let dialogRef = this.dialog.open(PendingApprovalDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? name : new_Data, type: type, category: this.docCategory, pagename: 'employee-doc' }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  doctypeChange(docName) {
    this.openDialog(docName, 'create');
  }

  editDoc(docName) {
    localStorage.setItem('old', JSON.stringify(docName));
    if (docName.DocumentStatus === "Pending Approval" && (this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
      this.validateDoc(docName, 'update');
    } else {
      this.openDialog(docName, 'update');
    }
  }

  doApproveReject(docName) {
    let type = 'update'
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentTypeName: name,
      DocumentCategory: this.docCategory
    };

    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? docName : new_Data, type: type, category: this.docCategory, pagename: 'employee-doc' }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteDoc(doc) {
    doc.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(AgentEmployeeDocsDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: doc
    });
  }

  // Get the status color
  getStatusColor(status, updatedBy) {
    let response = this.getDocStatusColor.getStatusColor(status, updatedBy);
    this.approve_reject_button = response['Approve/Reject Button'];
    return response.CSS;
  }

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    let response = this.disabletheRow.disableRow(status, updatedBy);
    this.grey = response['Disable'];
    this.disable_edit = response['Disable_Edit'];
    return response.CSS;
  }
}

export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  DocumentStatus: String;
  FileEdit: any;
}




// WEBPACK FOOTER //
// ./src/app/components/employee-documents/employee-documents.component.ts